import { Component, OnInit, ViewEncapsulation } from '@angular/core';
// import { MatSort } from '@angular/material/sort'
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { AnnotationApiService } from 'src/app/shared/services/customer-api/annotation-api.service';

/**
 * This component display all the annotation created in the cockpit.
 */
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-annotation',
  templateUrl: './annotation.component.html',
  styleUrls: ['./annotation.component.scss'],
})
export class AdminAnnotationComponent implements OnInit {
  /**
   * the list of columns to display
   */
  displayedColumns: string[] = [
    'action',
    'time',
    'public',
    'entity',
    'title',
    'comment',
  ];

  /**
   * this is the angular table component
   */
  dataSource = new MatTableDataSource();
  // @ViewChild(MatSort) sort: MatSort

  /**
   * constructor
   */
  constructor(private annotationApi: AnnotationApiService) {}

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.inNotes();
  }

  /**
   * start the request
   */
  inNotes() {
    this.annotationApi.getNoteAll().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data);
      // this.dataSource.sort = this.sort
    });
  }

  /**
   * delete the annotation
   */
  inDelete(element) {
    if (window.confirm('Delete this annotation?')) {
      this.annotationApi.delNote(element).subscribe(() => {
        this.inNotes();
      });
    }
  }
}
